var container = document.querySelector('.tabs');

if (container != null) {
	var primary = container.querySelector('.-primary');
	var primaryItems = container.querySelectorAll('.-primary > li:not(.-more)');
	container.classList.add('--jsfied');

	// insert "more" button and duplicate the list

	primary.insertAdjacentHTML('beforeend', '\n<li class="-more">\n<button type="button" aria-haspopup="true" aria-expanded="false">\n<span><div class="lines"><div class="line"></div></div>Show All</span>\n</button>\n<ul class="-secondary">\n' + primary.innerHTML + '\n</ul>\n</li>\n');

	var secondary = container.querySelector('.-secondary');
	var secondaryItems = secondary.querySelectorAll('li');
	var allItems = container.querySelectorAll('li');
	var moreLi = primary.querySelector('.-more');
	var moreBtn = moreLi.querySelector('button');

	moreBtn.addEventListener('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		container.classList.toggle('--show-secondary');
		moreBtn.setAttribute('aria-expanded', container.classList.contains('--show-secondary'));

		if(container.classList.contains('--show-secondary')) {
			document.addEventListener('click', closeSecondary);
		}
		else {
			document.removeEventListener('click', closeSecondary);
		}
	});

	// adapt tabs

	var doAdapt = function doAdapt() {
		// reveal all items for the calculation
		allItems.forEach(function (item) {
			item.classList.remove('--hidden');
		});

		// hide items that won't fit in the Primary
		var stopWidth = moreBtn.offsetWidth;
		var hiddenItems = [];
		var primaryWidth = primary.offsetWidth;

		primaryItems.forEach(function (item, i) {
			if (primaryWidth >= stopWidth + item.offsetWidth) {
				stopWidth += item.offsetWidth;
			} else {
				item.classList.add('--hidden');
				hiddenItems.push(i);
			}
		});


		// toggle the visibility of More button and items in Secondary
		if (!hiddenItems.length) {
			moreLi.classList.add('--hidden');
			closeSecondary();
			moreBtn.setAttribute('aria-expanded', false);
		} else {
			secondaryItems.forEach(function (item, i) {
				if (!hiddenItems.includes(i)) {
					item.classList.add('--hidden');
				}
			});
		}
	};

	doAdapt(); // adapt immediately on load
	window.addEventListener('resize', doAdapt); // adapt on window resize

	// hide Secondary on the outside click
	function closeSecondary() {
		container.classList.remove('--show-secondary');
		moreBtn.setAttribute('aria-expanded', false);
		document.removeEventListener('click', closeSecondary);
	}
}
